import { Ref } from 'react';
import { Flex } from 'antd';
import styled from 'styled-components';
import { WarningCircle } from '../icons';

interface FieldErrorMessageProps {
  text: string;
  /** Lets the invalid field name this message as its description (aria-describedby). */
  id?: string;
  ref?: Ref<HTMLDivElement>;
}

const FieldErrorMessageWrapper = styled(Flex)`
  margin-top: 5px;
  color: var(--clr-inline-error);
  p {
    font-style: italic;
    font-size: 11px;
    line-height: 15px;
  }
  .icon {
    flex-shrink: 0;
    font-size: 12px;
    svg path {
      fill: currentColor;
    }
  }
`;

const FieldErrorMessage = ({ text, id, ref }: FieldErrorMessageProps) => {
  return (
    <FieldErrorMessageWrapper id={id} ref={ref} data-testid="field-error-message" gap={2}>
      <WarningCircle />
      <p>{text}</p>
    </FieldErrorMessageWrapper>
  );
};

export default FieldErrorMessage;
